<section>
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">{{'PaymentPro' | translate}}</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">{{'PaymentPro' | translate}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-cart-area bg-color-white rbt-section-gap">
        <div class="cart_area">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="resultCon" *ngIf="this.done===false">
                            <h1>{{'paymentFailed' | translate}}</h1>
                            <img src="../../../assets/imgs/icons/broken.png" alt="broken">
                        </div>
                        <div class="resultCon" *ngIf="this.done===true">
                            <h1>{{'paymentSucss' | translate}}</h1>
                            <img src="../../../assets/imgs/icons/verified.png" alt="verified">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
